import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

// varios
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Localizacion - LOCALE_ID es el token que establece la configuración regional de la aplicación.
import { registerLocaleData } from '@angular/common';
import localEs from '@angular/common/locales/es-419';

// Route:
import { AppRoutingModule } from './app-routing.module';

// Servicios
import { HttpClientModule } from '@angular/common/http';
import { ContactoViaMailService } from './servicios/publicos/contacto-via-mail.service';

// Components:
// Components de diseño:
import { AppComponent } from './app.component';
import { HeaderComponent } from './componentes/header/header.component';
import { FooterComponent } from './componentes/footer/footer.component';

// Components de Pantallas Generales:
import { PantallaPrincipalComponent } from './componentes/pantallasGenerales/pantalla-principal/pantalla-principal.component';
import { PantallaInstitucionalComponent } from './componentes/pantallasGenerales/pantalla-institucional/pantalla-institucional.component';
import { PantallaContactoComponent } from './componentes/pantallasGenerales/pantalla-contacto/pantalla-contacto.component';
import { UsuarioLoginComponent } from './componentes/pantallasGenerales/pantallasLogin/usuario-login/usuario-login.component';
import { PantallaInscripcionesComponent } from './componentes/pantallasGenerales/pantalla-inscripciones/pantalla-inscripciones.component';
import { PantallaPropuestaEducativaComponent } from './componentes/pantallasGenerales/pantalla-propuesta-educativa/pantalla-propuesta-educativa.component';
import { PantallaExamenesComponent } from './componentes/pantallasGenerales/pantalla-examenes/pantalla-examenes.component';
import { PantallaPastoralComponent } from './componentes/pantallasGenerales/pantalla-pastoral/pantalla-pastoral.component';
import { PantallaProyectosSolidariosComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-proyectos-solidarios/pantalla-proyectos-solidarios.component';
import { PantallaConvivenciasComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-convivencias/pantalla-convivencias.component';
import { PantallaEstudiantesComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-estudiantes/pantalla-estudiantes.component';
import { PantallaPromocionesPasadasComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-promociones-pasadas/pantalla-promociones-pasadas.component';
import { PantallaActosComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-actos/pantalla-actos.component';
import { PantallaFiestaSanJeronimoComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-fiesta-san-jeronimo/pantalla-fiesta-san-jeronimo.component';



// Funciones
registerLocaleData(localEs);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PantallaPrincipalComponent,
    PantallaInstitucionalComponent,
    PantallaContactoComponent,
    UsuarioLoginComponent,
    PantallaInscripcionesComponent,
    PantallaPropuestaEducativaComponent,
    PantallaExamenesComponent,
    PantallaPastoralComponent,
    PantallaProyectosSolidariosComponent,
    PantallaConvivenciasComponent,
    PantallaEstudiantesComponent,
    PantallaPromocionesPasadasComponent,
    PantallaActosComponent,
    PantallaFiestaSanJeronimoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    ContactoViaMailService,
    { provide: LOCALE_ID, useValue: 'es-419' }
  ],
  bootstrap: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PantallaPrincipalComponent,
    PantallaInstitucionalComponent,
    PantallaContactoComponent,
    UsuarioLoginComponent,
    PantallaInscripcionesComponent
  ]
})
export class AppModule { }


//"C:\Program Files (x86)\Google\Chrome\Application\Chrome.exe" --allow-file-access-from-files

